import React from 'react';
import { ShieldCheck, Zap, Lock, MapPin } from 'lucide-react';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#091A0F] py-24 px-4 text-center" data-id="element-81">
      <div className="max-w-4xl mx-auto" data-id="element-82">
        <div className="text-6xl mb-8" data-id="element-83">🏉</div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#CCFF00] mb-6 leading-tight drop-shadow-[0_0_10px_rgba(204,255,0,0.3)]" data-id="element-84">
          RUGBY 360 — El sistema de planificación N°1 para entrenadores de rugby
          argentinos.
        </h2>

        <p className="text-xl text-white mb-12 italic font-light" data-id="element-85">
          "Porque preparar un buen entrenamiento no debería costarte todas las
          noches de la semana."
        </p>

        <button onClick={scrollToPricing} className="bg-[#39FF14] hover:bg-[#32E612] text-black text-xl md:text-2xl font-bold py-5 px-10 rounded-xl shadow-[0_0_30px_rgba(57,255,20,0.6)] transition-all transform hover:scale-105 w-full md:w-auto mb-10" data-id="element-86">
          💪 QUIERO MI RUGBY 360 AHORA
        </button>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-sm text-gray-300" data-id="element-87">
          <div className="flex items-center gap-2" data-id="element-88">
            <ShieldCheck size={18} data-id="element-89" />
            <span data-id="element-90">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-91">
            <Zap size={18} data-id="element-92" />
            <span data-id="element-93">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-94">
            <Lock size={18} data-id="element-95" />
            <span data-id="element-96">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-97">
            <MapPin size={18} data-id="element-98" />
            <span data-id="element-99">Hecho para Argentina</span>
          </div>
        </div>
      </div>
    </section>;
}